import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {FireEvent, Icon, MenuItem, NotificationMenu, User} from '../../../modules/global';
import {headerUserMenu} from './header-menu.config';
import { ThemePalette, MatRipple } from '@angular/material/core';
import { ButtonIconComponent } from '../../../modules/shared/components/buttons/button-icon/button-icon.component';
import { NgIf, NgFor } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { MonogramComponent } from '../../../modules/shared/components/monogram/monogram.component';
import { SvgIconComponent } from '../../../modules/shared/components/svg-icon/svg-icon.component';
import { ButtonComponent } from '../../../modules/shared/components/buttons/button/button.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { LoaderComponent } from '../../../modules/shared/components/loader/loader.component';
import { NamePipe } from '../../../modules/shared/pipes/name.pipe';
import { DateTransformPipe } from '../../../modules/shared/pipes/date-transform.pipe';

@Component({
    selector: 'slm-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonIconComponent, NgIf, MatTooltip, MatProgressSpinner, MatMenuTrigger, LanguageSelectorComponent, MatRipple, MonogramComponent, MatMenu, NgFor, MatMenuItem, SvgIconComponent, ButtonComponent, TranslateDirective, CdkScrollable, LoaderComponent, NamePipe, DateTransformPipe, TranslatePipe]
})
export class HeaderComponent {
  public readonly icons = Icon;

  public remainingDemoDays: number;
  public remainingDemoDaysValue: number;
  public progressSpinnerColor: ThemePalette = 'primary';
  public userMenu = headerUserMenu;
  public progressSpinnerTooltip = 'REMAINING_DAYS_IN_DEMO';

  @Input() public user: User;
  @Input() public notificationCount = 0;
  @Input() public notifications: Array<NotificationMenu> = [];
  @Input() public notificationLoading = false;
  @Input() public hasMoreNotification = true;
  @Output() public readonly fireEvent = new EventEmitter<FireEvent>();

  @Input('remainingDemoDays')
  public set _remainingDemoDays(value: number) {
    this.remainingDemoDaysValue = value > 0 ? (value / 30) * 100 : 100;
    this.remainingDemoDays = value;
    this.progressSpinnerColor = value > 0 ? 'primary' : 'warn';
    this.progressSpinnerTooltip = value > 0 ? 'REMAINING_DAYS_IN_DEMO' : 'DEMO_EXPIRED';
  }

  public trackNotificationById = (item) => item.id;
  public trackMenuByAction = (_, item: MenuItem) => item.action;

  public loadMoreNotification(event: Event){
    event.stopPropagation();
    this.fireEvent.emit({ event: 'notification_next' });
  }
}
